module.exports = __webpack_public_path__ + "img/kongzi big (9).ffd3e6ad.jpg";